import {put, takeLatest, call} from 'redux-saga/effects';
import * as productService from "../../../../services/productService";
import {
    TRANSFER_PRODUCT,
    TRANSFER_PRODUCT_SUCCESS,
    TRANSFER_PRODUCT_ERROR,
}
    from "../../../actions/menu/products";

function* transferProductSaga(action) {
    try {
        yield put({
            type: TRANSFER_PRODUCT_SUCCESS,
            payload: action.payload.payload
        });
        yield call(productService.TransferProduct,action.payload)
   


    } catch (error) {
        yield put({
            type: TRANSFER_PRODUCT_ERROR,error: error.data
        });
    }
}


export function* transferProductSagaWatcher() {
    yield takeLatest(TRANSFER_PRODUCT, transferProductSaga);
}